// Datos de demostración: José Pérez
// Perfil realista "en riesgo" - profesional de 37 años, sedentario, con factores de riesgo modificables

export const DEMO_USER = {
  uid: "demo_user",
  isDemo: true,
  email: "jose.perez@demo.we360.com",
  displayName: "José Pérez",
  photoURL: null,
};

export const DEMO_PROFILE = {
  // F1 - Datos demográficos
  email: "jose.perez@demo.we360.com",
  whatsapp: "+57 310 555 1234",
  nombres: "José",
  apellidos: "Pérez García",
  fechaNacimiento: "1988-05-15",
  sexo: "Masculino",
  estadoCivil: "Casado/a",
  nivelEducativo: "Universitario completo",
  profesion: "Ingeniero Industrial",
  ocupacion: "Gerente de operaciones",
  residencia: "Bogotá",
  
  // F1 - Datos clínicos
  peso: "86.5",
  talla: "174",
  cintura: "96",
  paSistolica: "132",
  paDiastolica: "84",
  glucemia: "108",
  oximetria: "97",
  condicionIds: ["hta1", "hiperglicemia", "sobrepeso"],
  condicionesAdicionales: [
    {
      nombre: "Hígado graso (esteatosis hepática)",
      codigoCIE10: "K76.0",
      codigoSNOMED: "197321007",
      source: "curated",
    },
  ],
  tabaco: "No",
  alcohol: "Ocasional",
  sueno: "6",
  usaMedicamentos: "Si",
  medicamentos: [
    {
      nombre: "Losartán",
      codigoATC: "C09CA01",
      dosis: "50mg",
      nombreComercial: "Cozaar",
      source: "curated",
    },
    {
      nombre: "Metformina",
      codigoATC: "A10BA02",
      dosis: "850mg",
      nombreComercial: "Glucophage",
      source: "curated",
    },
  ],
  consentimiento: true,
  createdAt: new Date().toISOString(),
  completedAt: new Date().toISOString(),

  // F2 - Estado Físico
  f2Results: {
    parqResponses: [false, false, false, false, false, false, false],
    parqAlerta: false,
    parqRiskCount: 0,
    parqOverride: false,
    caminata6min: 465,
    clasificacion6mwt: "Normal",
    sentadillas: 14,
    clasificacionSentadillas: "Promedio",
    flexiones: 13,
    clasificacionFlexiones: "Promedio",
    flexibilidad: "normal",
    clasificacionFlexibilidad: "Normal",
    confirmacion: true,
    createdAt: new Date().toISOString(),
    completedAt: new Date().toISOString(),
  },

  // F3 - Actividad Física IPAQ
  f3Results: {
    vigorosa: { dias: "1", tiempo: "30-60", metMin: 360 },
    moderada: { dias: "2", tiempo: "15-30", metMin: 180 },
    caminata: { dias: "4", tiempo: "15-30", metMin: 297 },
    metTotal: 837,
    clasificacionIPAQ: "moderate",
    tiempoSentado: "gt6",
    indiceSedentarismo: "very_high",
    createdAt: new Date().toISOString(),
    completedAt: new Date().toISOString(),
  },

  // F4 - Nutrición
  f4Results: {
    consumo: [
      { alimento: "Frutas frescas", frecuencia: "1-2 veces/semana" },
      { alimento: "Verduras frescas o cocidas", frecuencia: "3-4 veces/semana" },
      { alimento: "Cereales integrales", frecuencia: "1-2 veces/semana" },
      { alimento: "Productos refinados", frecuencia: "Diario (1 vez)" },
      { alimento: "Legumbres", frecuencia: "1-2 veces/semana" },
      { alimento: "Carnes magras o pescado", frecuencia: "3-4 veces/semana" },
      { alimento: "Lácteos o alternativas vegetales", frecuencia: "Diario (1 vez)" },
      { alimento: "Grasas saludables", frecuencia: "1-2 veces/semana" },
      { alimento: "Frituras o comida rápida", frecuencia: "3-4 veces/semana" },
      { alimento: "Bebidas azucaradas", frecuencia: "Diario (1 vez)" }
    ],
    scoreCalidadDieta: 19,
    categoriaCalidadDieta: "fair",
    conductas: [
      { pregunta: "¿Sueles saltarte comidas?", frecuencia: "A veces" },
      { pregunta: "¿Sueles pedir comida rápida?", frecuencia: "Frecuentemente" },
      { pregunta: "¿Planeas tus comidas?", frecuencia: "Nunca" },
      { pregunta: "¿Tomas agua regularmente?", frecuencia: "A veces" },
      { pregunta: "¿Añades azúcar a bebidas?", frecuencia: "Frecuentemente" }
    ],
    scoreConductas: 5,
    categoriaConductas: "risk",
    hidratacion: "low",
    motivaciones: ["Bajar de peso", "Mejorar energía o digestión"],
    nivelMotivacion: "Motivado/a",
    restricciones: ["Ninguna"],
    restriccionOtra: "",
    alergias: "",
    createdAt: new Date().toISOString(),
    completedAt: new Date().toISOString(),
  },

  // F5 - Bienestar Emocional
  f5Results: {
    ansiedad: { respuestas: [1, 1, 2, 2, 2], score: 8, categoria: "mild" },
    estres: { respuestas: [3, 3, 2, 2, 3], score: 13, categoria: "high" },
    bienestar: { respuestas: [3, 3, 2, 3, 3], score: 14, categoria: "high" },
    scoreGlobal: 58,
    categoriaGlobal: "moderate",
    comentario1: "Necesito más tiempo para mí y para hacer ejercicio, me siento atrapado en la rutina del trabajo.",
    comentario2: "Me gustaría bajar de peso y sentirme con más energía, pero no sé por dónde empezar.",
    createdAt: new Date().toISOString(),
    completedAt: new Date().toISOString(),
  },

  recommendations: {
    generatedAt: new Date().toISOString(),
    data: {
      status: "Success",
      summary: {
        resumen_ejecutivo: "¡Tu plan preventivo de longevidad personalizado está listo! Tus niveles de HRV y Presión sugieren una excelente resiliencia.",
        plan_maestro_hoy: {
          prioridad_numero_1: "Incrementar la actividad física ligera e hidratación constante.",
          micro_intervenciones: [
            "Caminata de 15 minutos por la mañana.",
            "Consumir al menos 2.2 litros de agua diariamente.",
            "Pausa activa de 5 minutos cada 2 horas de trabajo."
          ],
          coherencia_entre_pilares: "La nutrición apoya tu recuperación muscular después de las caminatas."
        },
        alertas_y_riesgos: {
          nivel_alerta: "green",
          motivo: "Ritmo cardíaco y presión arterial dentro de los límites saludables.",
          accion_requerida: "Mantener los hábitos actuales y repetir la medición rPPG semanalmente."
        },
        motivacion_y_logros: {
          reto_general_semanal: "Completar 10,000 pasos en al menos 4 días de la semana.",
          mensaje_coaching: "¡Pequeños pasos hoy construyen una gran longevidad mañana!"
        }
      },
      components: {
        physical: {
          classification: {
            nivel_riesgo: "bajo",
            Status_ID: "Óptimo",
            condicion_fisica: "Excelente capacidad aeróbica estimada.",
            objetivo: "Mantener fuerza y resistencia."
          },
          planSummary: "Plan de mantenimiento cardiovascular.",
          fases: {
            adaptacion: { descripcion: "Adaptación general", duracion: "1 semana" },
            progresion: { descripcion: "Incremento progresivo de pasos", duracion: "2 semanas" },
            consolidacion: { descripcion: "Consolidación de hábitos", duracion: "1 semana" }
          },
          verticales: {
            fuerza: "Ejercicios con peso corporal dos veces por semana.",
            cardio: "Caminatas rápidas o trote ligero."
          },
          gamificacion: {
            logro: "Iniciador Activo"
          }
        },
        nutrition: {
          classification: {
            nivel_riesgo: "bajo",
            Status_ID: "Bueno",
            condicion_fisica: "Dieta balanceada",
            objetivo: "Reducir azúcares refinados"
          },
          planSummary: "Plan nutricional rico en antioxidantes.",
          fases: {
            adaptacion: { descripcion: "Sustitución de refrescos por agua", duracion: "1 semana" }
          },
          verticales: {
            dieta: "Aumentar porción de verduras verdes."
          },
          gamificacion: {
            logro: "Comensal Consciente"
          }
        },
        emotional: {
          classification: {
            nivel_riesgo: "bajo",
            Status_ID: "Estable",
            condicion_fisica: "Buen manejo de estrés.",
            objetivo: "Optimizar el sueño reparador"
          },
          planSummary: "Higiene del sueño y meditación.",
          fases: {
            adaptacion: { descripcion: "Meditación de 5 minutos antes de dormir", duracion: "1 semana" }
          },
          verticales: {
            mindfulness: "Ejercicios de respiración profunda (4-7-8) durante picos de trabajo."
          },
          gamificacion: {
            logro: "Mente Serena"
          },
          educacion_neurociencia: {
            capsula_microlearning: "La variabilidad del ritmo cardíaco (HRV) es un excelente indicador del equilibrio del sistema nervioso autónomo. Niveles altos se asocian con salud cardiovascular y resiliencia."
          }
        }
      }
    }
  },
};
